// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fea6fbcf","488":"94f7df3e","732":"cb5f25c5"}[chunkId] + ".chunk.js";
};